// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Ice Shield",
  id: "ice-shield",
  metadata: {
    aspect: SavedSpellAspect.Ice,
    imports: ["ice","shapes","vector","wait"],
    icon: {
      "backgroundColor": 2306626,
      "layers": [
        {
          "iconKey": "iceBolt",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": 1,
          "color": 312063
        },
        {
          "iconKey": "delay",
          "position": {
            "x": 17,
            "y": 2
          },
          "scale": 0.61,
          "rotation": -5,
          "color": 16646135
        }
      ]
    },
  },
};

export default metadata;
